import { render, staticRenderFns } from "./video-wrap.vue?vue&type=template&id=004dc89e&lang=pug&"
import script from "./video-wrap.vue?vue&type=script&lang=js&"
export * from "./video-wrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports